import React from 'react';
import PropTypes from 'prop-types';

import CustomTable from '@ey/canvascoreservices/CustomTable';

import Utility from '../../../../../../../../util/utilityfunctions';
import {labels} from '../../../../../../../../util/utils';

import EmptyMessage from '../../../../../../../Common/Messages/EmptyMessage';

import StyleTable from './StyledMissingDomainsTable';

const MissingDomainsTable = ({domains}) => {
	const columns = [
		{
			id: 0,
			label: labels.addExternalContactColumnName,
			sort: 'asc',
			propName: 'entityName',
			width: '50%'
		},
		{
			id: 1,
			label: labels.addExternalContactColumnDomain,
			sortable: false,
			propName: 'domains',
			width: '50%'
		}
	];

	const renderMissingDomains = () => {
		const props = {
			theme: Utility.getMotifTheme(),
			columns: columns,
			items: domains,
			noResultFoundMessage: <EmptyMessage title={labels.thereIsNoDataToDisplay} />,
			hoverShadow: false,
			searchConfig: {
				disabled: true
			},
			paginationConfig: {
				disabled: true
			}
		};

		return (
			<StyleTable>
				<CustomTable {...props} />
			</StyleTable>
		);
	};

	return renderMissingDomains();
};

MissingDomainsTable.propTypes = {
	domains: PropTypes.arrayOf.isRequired
};

MissingDomainsTable.defaultProps = {};

export default MissingDomainsTable;
